
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Check } from 'lucide-react';

const ShopwareAssessment = () => {
  return (
    <section className="py-16 md:py-24 bg-gradient-to-br from-blue-50 to-gray-50">
      <div className="container">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Für wen ist Shopware die richtige Wahl?
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Finde heraus, ob Shopware die optimale Lösung für dein E-Commerce-Business ist
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <Card className="border-2 border-blue-200 bg-white">
            <CardContent className="p-8">
              <ul className="space-y-5">
                <li className="flex items-start">
                  <Check className="h-6 w-6 text-green-500 mr-3 flex-shrink-0 mt-0.5" />
                  <div>
                    <p className="text-lg font-semibold mb-1">Suchst du eine skalierbare Lösung für B2B oder B2C?</p>
                    <p className="text-gray-600">Shopware wächst mit deinem Unternehmen und bietet spezifische Funktionen für beide Geschäftsmodelle.</p>
                  </div>
                </li>
                
                <li className="flex items-start">
                  <Check className="h-6 w-6 text-green-500 mr-3 flex-shrink-0 mt-0.5" />
                  <div>
                    <p className="text-lg font-semibold mb-1">Willst du eine individuelle Shop-Lösung, die zu deinen Geschäftsprozessen passt?</p>
                    <p className="text-gray-600">Mit Shopware können wir deinen Shop exakt an deine spezifischen Anforderungen anpassen.</p>
                  </div>
                </li>
                
                <li className="flex items-start">
                  <Check className="h-6 w-6 text-green-500 mr-3 flex-shrink-0 mt-0.5" />
                  <div>
                    <p className="text-lg font-semibold mb-1">Möchtest du dein ERP, CRM oder PIM nahtlos mit deinem Shop verbinden?</p>
                    <p className="text-gray-600">Shopware bietet zahlreiche Integrationsmöglichkeiten und Schnittstellen zu anderen Systemen.</p>
                  </div>
                </li>
                
                <li className="flex items-start">
                  <Check className="h-6 w-6 text-green-500 mr-3 flex-shrink-0 mt-0.5" />
                  <div>
                    <p className="text-lg font-semibold mb-1">Ist dir eine hohe Performance & Nutzerfreundlichkeit wichtig?</p>
                    <p className="text-gray-600">Shopware überzeugt mit schnellen Ladezeiten und einer intuitiven Benutzeroberfläche.</p>
                  </div>
                </li>
                
                <li className="flex items-start">
                  <Check className="h-6 w-6 text-green-500 mr-3 flex-shrink-0 mt-0.5" />
                  <div>
                    <p className="text-lg font-semibold mb-1">Willst du langfristig mehr Umsatz & höhere Conversion-Raten erzielen?</p>
                    <p className="text-gray-600">Mit optimierter User Experience und verkaufspsychologischen Elementen steigern wir deine Conversion.</p>
                  </div>
                </li>
              </ul>
              
              <div className="mt-8 p-4 bg-blue-50 rounded-md text-center">
                <p className="text-lg font-medium text-blue-800">
                  Wenn du mindestens drei dieser Fragen mit „Ja" beantwortet hast, ist Shopware die perfekte Lösung für dich.
                </p>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default ShopwareAssessment;
